import React from "react";
import InfoCard from "../../../components/ui/InfoCard";

const About = ({ description }) => {
  return (
    <InfoCard title="About Me">
      <div
        className="ql-editor !min-h-0 !p-0 pt-2"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </InfoCard>
  );
};

export default About;
